const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? (typeof window !== 'undefined' ? window.location.origin : '')
    : "http://localhost:8000");

export const ANON_KEY = 'neutralfit_anonymous_id';

export const getAnonymousClientId = (): string => {
  if (typeof window === 'undefined') {
    return 'server-side';
  }

  let anonymousId = localStorage.getItem(ANON_KEY);
  if (!anonymousId) {
    anonymousId = crypto.randomUUID();
    localStorage.setItem(ANON_KEY, anonymousId);
  }
  return anonymousId;
};

export const buildApiHeaders = (extraHeaders: Record<string, string> = {}): Record<string, string> => {
  return {
    ...extraHeaders,
    'x-anonymous-id': getAnonymousClientId(),
  };
};

export default API_BASE_URL;